<template>
  <div class="m-5">
    <d-table :data="data">
      <template #action-buttons>
        <d-btn @click="isModalActive = true">
          Add New
        </d-btn>
      </template>
      <template v-if="showActions" #actionsColumn="props">
        <d-icon icon="edit" class="mr-2 cursor-pointer" @click.native="showEditModal(props.row)" />
        <d-icon icon="trash" class="cursor-pointer" @click.native="deleteItem(props.row)" />
      </template>
    </d-table>

    <d-modal :active.sync="isModalActive" has-modal-card>
      <form @submit.prevent="processModalSubmit">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p v-if="crudForm.newHeader && !showEdit" class="modal-card-title">
              {{ crudForm.newHeader }}
            </p>
            <p v-if="crudForm.editHeader && showEdit" class="modal-card-title">
              {{ crudForm.editHeader }}
            </p>
          </header>
          <section class="modal-card-body">
            <d-field v-for="field in crudForm.fields" :key="field.name" :label="field.label" :horizontal="crudForm.horizontalFields">
              <d-input v-if="field.type === 'TextInput'" v-model="newForm[field.name]" type="text" :placeholder="field.placeholder" :required="field.required" />
            </d-field>
          </section>
          <footer class="modal-card-foot flex justify-end">
            <d-btn tag="a" @click="isModalActive = false">
              Close
            </d-btn>
            <d-btn type="submit">
              Save
            </d-btn>
          </footer>
        </div>
      </form>
    </d-modal>
  </div>
</template>

<script>
  import TableMixin from '../../../utils/mixins/tableMixin.js';

  export default {
    mixins: [TableMixin],
    props: {
      crudForm: {
        type: Object,
        default: () => {},
        validator(obj) {
          return obj.formObject && obj.fields;
        },
      },

      crudOps: {
        type: Object,
        default: () => {},
      },

      showActions: Boolean,
    },

    data: vm => ({
      isModalActive: false,
      newForm: JSON.parse(JSON.stringify(vm.crudForm.formObject)) || {},
      showEdit: false,
    }),

    watch: {
      isModalActive(val) {
        if (!val) {
          setTimeout(() => {
            this.showEdit = false;
            this.newForm = JSON.parse(JSON.stringify(this.crudForm.formObject));
          }, 300);
        }
      },
    },

    methods: {
      processModalSubmit() {
        if (this.showEdit) {
          this.update();
        } else {
          this.create();
        }
      },

      async create() {
        console.log(this.crudOps.createUrl);
        // await axios.post(this.createUrl(payload), payload);
      },

      async update() {
        console.log(this.crudOps.updateUrl(this.crudForm.formObject));
        // await axios.patch(this.createUrl(payload), payload);
      },

      showEditModal(item) {
        this.showEdit = this.isModalActive = true;
        this.newForm = item;
      },

      async deleteItem(item) {
        console.log(this.crudOps.deleteUrl(item));
      },
    },
  };
</script>
